import { createContext, useContext, useState } from 'react'
import { SearchBarPortalContextValue, SearchBarPortalProviderProps } from './SearchBarPortalContextTypes'

const SearchBarPortalContext = createContext<SearchBarPortalContextValue>({
  setContainer: () => {},
  container: null,
})

const SearchBarPortalContextProvider = SearchBarPortalContext.Provider

export const SearchBarPortalProvider = ({ children }: SearchBarPortalProviderProps) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)

  const value = { container, setContainer }

  return <SearchBarPortalContextProvider value={value}>{children}</SearchBarPortalContextProvider>
}

export const useSearchBarPortalContext = () => {
  return useContext(SearchBarPortalContext)
}
